import { usePaneStore } from "../state/store-context";

/** Header readout of the FOCUSED field's rule message. Shows the message only
 *  when the active field is failing a rule (orange). Constraint-always-on is a
 *  deferred follow-up (design §3.3). */
export function FieldRuleReadout() {
  const field = usePaneStore((s) => s.fields[s.activeFieldIndex]);
  if (!field || field.validationStatus !== "fail" || !field.validationMessage) {
    return null;
  }
  return (
    <span className="vs-rule-readout vs-rule-readout--fail" data-testid="vs-rule-readout">
      {field.validationMessage}
    </span>
  );
}
